import * as moment from 'moment';

export const getCommentDate = (
    timestamp: number,
    ): string => {
    let dateStr;

    const date = moment(timestamp);
    const now = moment();

    if (date.isSame(now, 'day')) {
        dateStr = date.format('HH:mm');
    } else if (date.isSame(now, 'week')) {
        dateStr = date.format('ddd');
    } else {
        dateStr = date.format('DD.MM.YY');
    }

    return dateStr;
};
